import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  funds: {
    type: null,
    loading: false,
    options: [],
    details: {
      // loading: false,
      /* [fundId]: { fund detail } */
    }
  },
}

const slice = createSlice({
  initialState,
  name: "ultrahigh-master",
  reducers: {
    getFundList: (state, action) => {
      state.funds.loading = true;
      state.funds.type_request = action.payload.type
    },
    cancelFetchFund: (state) => {
      state.funds.loading = false;
    },
    getFundListSuccess: (state, action) => {
      state.funds.loading = false;
      state.funds.options = action.payload;
      state.funds.done = true
      state.funds.type = state.funds.type_request
    },
    getFundListFailure: (state) => {
      state.funds.loading = false;
      state.funds.done = true
    },
    clearAllFundDetail: (state) => {
      state.funds.details = {}
    },
    getFundById: (state, action) => {
      if (!state.funds.details[action.payload]?.detail) {
        state.funds.details[action.payload] = {
          loading: true,
        }
      }
    },
    getFundByIdSuccess: (state, action) => {
      state.funds.details[action.payload.fundId] = {
        loading: false,
        detail: action.payload.detail
      }
    },
    getFundByIdFailure: (state, action) => {
      delete state.funds.details[action.payload.fundId]
      // state.funds.details[action.payload.fundId] = null
    },
  },
})

export const {
  getFundList,
  getFundListSuccess,
  getFundListFailure,
  cancelFetchFund,
  getFundById,
  getFundByIdSuccess,
  getFundByIdFailure,
  clearAllFundDetail,
} = slice.actions;

export default slice.reducer;


